export default "__VITE_ASSET__b677cef9__"